import { Entity } from '@core/entities/entity'
import { AuthGroupPermittedActions } from '@core/entities/Groups/AuthGroups/types'
import { plainToInstance } from 'class-transformer'
import { ApprovalStage } from '@core/entities/permit/PermitApprovalReviews'

export class ProjectApprovalsAssignments extends Entity<ProjectApprovalsAssignments> {
  assignments: Array<{
    approval: {
      allowDeletion: boolean
      approvalStage: ApprovalStage
      id: string
      label: string
    }
    authGroups: Array<{
      id: number
      name: string
      projectId: number
      permittedActions: AuthGroupPermittedActions
    }>
    notificationEmails: Array<string>
  }>

  public static new(payload: unknown): ProjectApprovalsAssignments {
    const entity = plainToInstance(ProjectApprovalsAssignments, payload)

    return entity
  }

  public getAuthGroupsByApprovalId(approvalId: string) {
    return (
      this.assignments.find(
        (assignment) => assignment.approval.id === approvalId,
      )?.authGroups || []
    )
  }
}
